
const digest = '8924748a28c3079aa2c2428a055da877b31970fe3a716508d4c44ae12fc43ea1';
const classes = {"container":"_container_qvvn6_1","componentStep":"_componentStep_qvvn6_10"};
const css = `._container_qvvn6_1 {
  position: relative;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
  overflow-y: hidden;
}

._componentStep_qvvn6_10 {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow-y: hidden;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  